import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { WHATSAPP_NUMBER, WhatsAppIcon } from "@/lib/whatsapp";
import api from "@/lib/api";

const HIDDEN_ROUTES = ["/admin", "/login", "/register", "/forgot-password", "/reset-password", "/recover"];

export default function WhatsAppFab() {
  const { pathname } = useLocation();
  const [mounted, setMounted] = useState(false);
  const [waNumber, setWaNumber] = useState(WHATSAPP_NUMBER);

  useEffect(() => {
    // Mount after splash so the bubble does not appear behind it.
    const t = setTimeout(() => setMounted(true), 2000);
    // Fetch admin-editable WhatsApp number (falls back to compiled default).
    api.get("/settings/site")
      .then(({ data }) => {
        if (data?.whatsapp_number) setWaNumber(data.whatsapp_number.replace(/\s|\+/g, ""));
      })
      .catch(() => {});
    return () => clearTimeout(t);
  }, []);

  if (!mounted) return null;
  if (HIDDEN_ROUTES.some((p) => pathname.startsWith(p))) return null;

  const text =
    "Hi Riddhi 🌸 I'd like to know more about your collection at Drape the Elegance.";
  const href = `https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with Riddhi on WhatsApp"
      className="fixed bottom-20 right-5 md:bottom-8 md:right-7 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
      <span className="relative flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_8px_28px_rgba(37,211,102,0.45)] ring-2 ring-white/40 backdrop-blur transition-transform duration-300 hover:scale-[1.04] hover:shadow-[0_12px_32px_rgba(37,211,102,0.55)]">
        <WhatsAppIcon size={22} className="text-white" />
        <span className="hidden sm:inline text-[11px] tracking-overline uppercase font-medium">
          Chat with us
        </span>
      </span>
    </a>
  );
}
